import React from 'react'

function ClassicDashboard() {
  return (
    <div>
      <div className="grid grid-cols-3 gap-4">
            <div className="bg-blue-500 p-4">Add New Inventory</div>
            <div className="bg-green-500 p-4">Returns</div>
            <div className="bg-red-500 p-4">Advertisment</div>
        </div>

        <div className='bg-blue-500 mt-4'>
          Some Action Buttons
        </div>
    </div>
  )
}

export default ClassicDashboard